import React from 'react';
import {useHistory} from 'react-router-dom';
import '../CSS/Marks.css';
import { motion} from 'framer-motion';
import LeftArrow from '../Images/leftArrow.png';
import Refresh from '../Images/refresh.png';
import Loading from '../Components/Loading';
import { pageTransition, pageStyle, pageVariants } from '../Components/Animations/Transition';
import {getUrl} from '../Functions.js';


function Marks(props) {
  const history  = useHistory();
  if(localStorage.getItem("loggedIn")!=="true"){
    history.push("/opening");
  }
  
  const cookie = localStorage.getItem("cookie");
  const [marks, setMarks] = React.useState("");
  const [selectedSem, setSelectedSem] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [allSems, setAllSems] = React.useState([]);
  var update = false;
  const loadingHeight = "100vh";

  var options = {};

  function setOptions(semester=""){
      options = {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: (
          semester===""?
        JSON.stringify({ 
          cookies: cookie,
        })
        :
        JSON.stringify({ 
          cookies: cookie,
          sem: semester
        })
        )
      }
  }

  function back(){
    history.push("/home");
  }

  function initialFetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }

    setLoading(true);
    setOptions(selectedSem);
    fetch(getUrl()+'currentSem', options)
      .then(response => response.json()).then(
        data=>{
          if(data.retry===true){
            console.log("retrying...");
            initialFetchData();
        }else{   
          setSelectedSem(data.sem);
          setAllSems([])
          fetchSems(data.sem);
          setOptions(data.sem);
          fetchData();
        }
        }
      )
  }

  function fetchData(){
    if(localStorage.getItem("loggedIn")!=="true"){
      history.push("/opening");
    }
    setLoading(true);
    fetch(getUrl()+'marks', options)
      .then(response => response.json()).then(
        data =>{
        if(data.retry===true){
            console.log("retrying...");
            fetchData();
        }else{    
            setMarks(data.lastSemMarks);
            update = false;
            setLoading(false);
        }
        }
      );
  }

  function fetchSems(current){
    setAllSems(allSems =>[...allSems, current]);
    current = current - 1;
    if(current!=0)
      fetchSems(current)

  }

  function semChange(sem){
    console.log("sem = " + sem);
    setSelectedSem(sem);
    setOptions(sem);
    fetchData();
  }
  
  React.useEffect(() => {
    initialFetchData();
  },[]);

  return (
    <motion.div className="MarksMain"
    initial="initial"
    animate="in"
    exit="out"
    style={pageStyle}
    variants={pageVariants}
    transition={pageTransition}>
      <div className="TopMarks">
        <img src={LeftArrow} alt="back" className="BackMarks" onClick={()=>{
          back();
        }} color="#000000" />
        <div ></div>
        <img src={Refresh} alt="refresh" className="RefreshMarks" onClick={()=>{
          if(update!==true){
            update = true;
            initialFetchData();
          }}} color="#000000"/>
      </div>
      {loading===true?<Loading height={loadingHeight} color="#ffffff"/>:
        <div className="BottomMarks">
          
          <div 
            className="Marks"
            dangerouslySetInnerHTML={{__html: marks}}
            />
          
        </div>
      }
    </motion.div>
  );

}



export default Marks;